import React from 'react';
import { Route, Switch } from 'react-router';
import { techRoutes } from './constants';

export const TechMenuRoutes = () => {

  return (
		<Switch>
			{
				techRoutes.map((route, index) => {
					return (
						<Route 
							key={index}
							path={route.path}
							exact={route.exact}
							render={() => <route.component />} />						
					)
				})
			}
		</Switch>
	);
}